import React from "react";
import { Generatepinm } from "../../Model/Users"; //Include Home
import {
  Link
} from "react-router-dom";

import { withRouter, VirsionCheck } from "../../Helpers/Common"; //Include Home
import { SVGIcons, ImgIcons } from "../../Helpers/Common";
import { Helmet } from "react-helmet";
import Profilemenu from "../Profile_menu/Profilemenu";
import { Mobilemenu } from "../Mobile_menu/Mobilemenu";
import { isMobile } from "react-device-detect";
import { Metadata } from "../Metadata/Metadata";
import BarLoader from "react-spinners/BarLoader";
var ImageData = "";
var SVGIcon = "";
ImgIcons().then((result) => (ImageData = result));
SVGIcons().then((resultData) => (SVGIcon = resultData));

class Generatepin extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      VirsionCheckData: [],
      VirsionCheckDataloaded: false,
      DataisLoaded: false,
      Pindata: false,
      isLive:true
    };
  }

  componentDidMount() {
    //Get Virsion Check Data
    VirsionCheck().then((vcheckres) => {
      this.setState({
        isLive: JSON.parse(vcheckres.data).data.is_live_tv
      });
      Generatepinm().then((Generatepin) => {
        if (Generatepin.data.success == false) {
          this.props.navigate("/createaccount");
        } else {
          this.setState({
            VirsionCheckData: vcheckres,
            VirsionCheckDataloaded: true,
            DataisLoaded: true,
            Pindata: Generatepin
          });
        }

      })
    });
  }

  regeneratepin() {
    Generatepinm().then((Generatepin) => {
      this.setState({
        Pindata: Generatepin
      });
    })
  }
  /*-----Logout Confirmation popup*/
  logoutconfirm() {
    this.setState({
      showconfirm: true,
    });
  }

  /*-------Logout-------*/
  Logout() {
    //Call logout Api

  }

  cancel() {
    //Call logout Api
    this.setState({
      showconfirm: false,
    });
  }

  render() {

    if (this.state.VirsionCheckDataloaded == false) {
      // return <div className="loader"></div>;
      return <div className="loader"><BarLoader color="#ff000f" /></div>;
    } else {

      var MetaData = JSON.parse(this.state.VirsionCheckData.data).data.page
        .signup;
      var GeneratepinData = JSON.parse(this.state.Pindata.data.message);
      return (
        <>
          <Metadata page="GENERATE-PIN" />
          <>
            <header>
              <div className="mainNav pmenu dD-none">
                <div className="docubayBack white">
                  <Link to="/profile">
                    <img src={SVGIcon['back.svg']} alt="DocuBay" />
                  </Link>
                  TV Pin
                </div>
              </div>
            </header>

            <main className="dD-none">
              <section className="mb-0">
                <div className="temp63">
                  <img src={ImageData['tv-pin.png']} alt="TV Icons" />
                </div>
              </section>
              <section className="mb-0">
                <div className="temp64">
                  <h4>Enter this PIN on your</h4>
                  <h3>
                    TV Screen <span> to get started</span>
                  </h3>
                </div>
              </section>
              <section className="mb-0">
                <div className="temp65">
                  <img src={ImageData['tv-pin-bg.png']} alt="" className="w-100" />
                  <div className="temp65-area">{GeneratepinData.pin}</div>
                </div>
              </section>
              <div className="temp66">
                <a onClick={() => { this.regeneratepin() }}>Regenerate PIN</a>
              </div>
            </main>
            <div className="profile-back-desk dD-block">
              <Link to="/">
                <div className="docubayBack white">
                  <img src={SVGIcon["back.svg"]} alt="DocuBay" />
                </div>
              </Link>
            </div>
            <main className="setting-main dD-block">
              <section className="mb-0">
                <div className="temp63">
                  <img src={ImageData['tv-pin.png']} alt="TV Icons" />
                </div>
              </section>
              <section className="mb-0">
                <div className="temp64">
                  <h4>Enter this PIN on your</h4>
                  <h3>
                    TV Screen <span> to get started</span>
                  </h3>
                </div>
              </section>
              <section className="mb-0">
                <div className="temp65">
                  <img src={ImageData['tv-pin-bg.png']} alt="" className="w-100" />
                  <div className="temp65-area">{GeneratepinData.pin}</div>
                </div>
              </section>
              <section>
                <div className="temp66">
                  <a onClick={() => { this.regeneratepin() }}>Regenerate PIN</a>
                </div>
              </section>
            </main>
            {isMobile ? <Mobilemenu active="5" isLive={this.state.isLive}/> : <Profilemenu userdata={this.state.userData} />}
          </>
        </>
      );
    }
  }
}
export default withRouter(Generatepin);
